import { Button } from "@/components/ui/button";

interface CookieBannerContentProps {
  onAcceptAll: () => void;
  onAcceptNecessary: () => void;
}

export const CookieBannerContent = ({
  onAcceptAll,
  onAcceptNecessary
}: CookieBannerContentProps) => {
  return (
    <div className="container mx-auto max-w-7xl">
      <div className="flex flex-col md:flex-row items-center justify-between gap-2 md:gap-4">
        <div className="flex-1">
          <p className="text-xs sm:text-sm text-muted-foreground">
            Les cookies nécessaires assurent le fonctionnement du site. Les autres sont facultatifs. {" "}
            <a href="/legal/privacy" className="underline underline-offset-2 text-foreground">Politique de confidentialité</a>
          </p>
        </div>
        <div className="flex gap-2 shrink-0 w-full md:w-auto">
          <Button
            variant="outline"
            size="sm"
            onClick={onAcceptNecessary}
            className="text-xs sm:text-sm flex-1 md:flex-none"
          >
            Refuser les cookies facultatifs
          </Button>
          <Button
            variant="default"
            size="sm"
            onClick={onAcceptAll}
            className="text-xs sm:text-sm flex-1 md:flex-none"
          >
            Accepter tous les cookies
          </Button>
        </div>
      </div>
    </div>
  );
};